/**
 * «Исследователь метрик»: словари подписей — качество значения и коды проблем качества данных.
 * Неизвестный код показывается как есть (новый код сервера не должен ломать экран).
 */

import { EXTRA_ISSUE_LABELS, translateLimitation } from './limitationTexts'

export const QUALITY_LABELS: Record<string, string> = {
  partial: 'частично',
  unavailable: 'нет данных',
}

export const QUALITY_HINTS: Record<string, string> = {
  partial: 'Источник загружен не полностью или период выходит за границы данных: число может измениться.',
  unavailable: 'Значения нет: источник не загружен или не хватает зависимости. Это не ноль.',
}

/** Коды `quality.issues[].code`, `quality.sourceIssues` и `quality.sources[].quality.issues`. */
export const ISSUE_LABELS: Record<string, string> = {
  LOAD_COMPLETENESS_NOT_REGISTERED: 'Полнота загрузки источника не зафиксирована: данные могут быть неполными.',
  LOAD_NOT_CONFIRMED_FOR_DAYS: 'Загрузка не подтверждена за часть дней периода.',
  SOURCE_COMPLETENESS_NOT_PROVEN: 'Полнота источника не подтверждена.',
  COMPLETENESS_UNKNOWN: 'Полнота данных неизвестна.',
  DATA_INCOMPLETE: 'Данные за период неполные.',
  PERIOD_AFTER_LAST_LOADED_DAY: 'Период заканчивается позже последнего загруженного дня источника.',
  PERIOD_BEFORE_SOURCE_START: 'Период начинается раньше, чем у источника есть данные.',
  PERIOD_OUTSIDE_SOURCE: 'Период целиком вне границ данных источника.',
  DEPENDENCY_UNAVAILABLE: 'Расчёт невозможен: не хватает исходной метрики. Значение пустое, а не ноль.',
  SOURCE_UNAVAILABLE: 'Источник данных недоступен.',
  SOURCE_HISTORY_MUTABLE: 'Источник дописывает историю задним числом: недавние дни могут измениться.',
  STOCK_UNCERTAIN: 'Остаток определён неуверенно.',
  COGS_MISSING: 'У части товаров нет себестоимости.',
  COGS_ESTIMATED: 'Себестоимость частично оценочная.',
  FINANCE_PROVISIONAL: 'Финансовые данные предварительные: отчёт площадки ещё не закрыт.',
  FINANCE_UNCLASSIFIED: 'Часть начислений не классифицирована.',
  RESULT_TRUNCATED: 'Результат обрезан по лимиту строк.',
  DETAILS_SAMPLED: 'Детализация выбрана выборкой, а не целиком.',
  ACCEPTED_QTY_UNKNOWN_FOR_OLD_SUPPLIES: 'У старых поставок принятое количество площадка не отдаёт.',
  ABSENCE_IS_NOT_ZERO: 'Отсутствие записи не означает ноль.',
  REGION_MEASURE_BREAK: 'Период пересекает смену способа измерения регионов: до и после несопоставимы.',
  PRODUCT_DAY_PANEL_NOT_BUILT: 'Дневная витрина товаров ещё не построена.',
  PRICE_TOTAL_UNDEFINED: 'Итог цены не определён: цены не суммируются.',
  SCHEMA_MISMATCH: 'Структура данных источника не совпала с ожидаемой.',
  QUERY_TIMEOUT: 'Запрос не уложился во время.',
}

/** Текст проблемы качества по коду; неизвестный код — как есть. */
export const issueText = (code: string): string => ISSUE_LABELS[code] ?? EXTRA_ISSUE_LABELS[code] ?? code

/**
 * Ограничения факта приходят строкой вида «CODE: пояснение» или обычным текстом. Код выделяется отдельно
 * (моноширинным), пояснение сервера остаётся как есть; английские формулировки слоя переводятся словарём
 * (`translateLimitation`), неизвестные остаются без изменений.
 */
export function splitLimitation(value: string): { code: string | null; text: string } {
  const match = /^([A-Z][A-Z0-9_]{2,}):\s*([\s\S]*)$/.exec(value)
  return match ? { code: match[1], text: translateLimitation(match[2]) } : { code: null, text: translateLimitation(value) }
}
